function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 30C28.1 30 29 29.1 29 28V14C29 12.9 28.1 12 27 12H26V10H24V12H16V10H14V12H13C11.89 12 11.01 12.9 11.01 14L11 28C11 29.1 11.89 30 13 30H27ZM17 21V19H15V21H17ZM13 16H27V14H13V16ZM27 18V28H13V18H27ZM25 21V19H23V21H25ZM21 21H19V19H21V21Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/DateIcon.413ecbb6.svg";
export { SvgComponent as ReactComponent };